<div class="modal-content">
  <div class="modal__content">
    <div class="modal__header">
      <h3 class="h3 modal__title">
        {{ 'sharedModule.bkgInitialBookingDataDialog.dates' | translate }}
      </h3>
      <button
        *ngIf="!errorShow"
        (click)="onClickClose()"
        type="button"
        class="modal__close"
      >
        <img src="assets/images/icons/close.svg" />
      </button>
    </div>

    <form *ngIf="form" [formGroup]="form" errorTailor>
      <div class="modal__body">
        <bkg-dialog-banner
          [isVisible]="!!errorMessage"
          [message]="errorMessage"
          (closeBanner)="onCloseBanner()"
        >
        </bkg-dialog-banner>
        <div class="form-compact">
          <div class="form-group" [class.mb-5]="hasErrors('startDate')">
            <label class="text-start">
              {{
                'sharedModule.bkgInitialBookingDataDialog.entrance' | translate
              }}
            </label>
            <input
              id="startDatePicker"
              #startDatePicker
              formControlName="startDate"
              placeholder="{{
                'sharedModule.bkgInitialBookingDataDialog.dateAndTime'
                  | translate
              }}"
              [class.warning]="hasErrors('startDate')"
              controlErrorsClass="info-field"
            />
          </div>

          <bkg-hour-picker
            [hourPickerId]="startHourPickerId"
            [visible]="showStartHourPicker"
            [style]="startHourPickerPosition"
            [selectedHour]="selectedStartHours"
            [customHours]="customHoursStart"
            [customRange]="customRange"
            [product]="placeProduct"
            (hourSelectedReturn)="onSelectedStartHour($event)"
            (outClickReturn)="onOutClickHourPickerStart($event)"
          ></bkg-hour-picker>

          <div class="form-group" [class.mb-5]="hasErrors('endDate')">
            <label class="text-start">
              {{ 'sharedModule.bkgInitialBookingDataDialog.exit' | translate }}
            </label>
            <input
              id="endDatePicker"
              #endDatePicker
              formControlName="endDate"
              placeholder="{{
                'sharedModule.bkgInitialBookingDataDialog.dateAndTime'
                  | translate
              }}"
              [class.warning]="hasErrors('endDate')"
              controlErrorsClass="info-field"
            />
          </div>

          <bkg-hour-picker
            [hourPickerId]="endHourPickerId"
            [visible]="showEndHourPicker"
            [style]="endHourPickerPosition"
            [selectedHour]="selectedEndHours"
            [customHours]="customHoursEnd"
            [customRange]="customRange"
            [product]="placeProduct"
            (hourSelectedReturn)="onSelectedEndHour($event)"
            (outClickReturn)="onOutClickHourPickerEnd($event)"
          ></bkg-hour-picker>
        </div>
        <bkg-trip-info-return-flight
          *ngIf="hasFlightNumber"
          [tripData]="tripData$ | async"
          (flightNumber)="onFlightNumber($event)"
        ></bkg-trip-info-return-flight>
        <bkg-trip-info-passengers
          *ngIf="hasPassengers"
          [tripData]="tripData$ | async"
          (passengers)="onChangePassengers($event)"
        ></bkg-trip-info-passengers>
        <bkg-trip-info-terminal
          *ngIf="hasTerminals && placeProduct"
          [tripData]="tripData$ | async"
          [product]="placeProduct"
          (terminals)="onChangeTerminals($event)"
        ></bkg-trip-info-terminal>
      </div>

      <div class="modal__footer">
        <button
          (click)="onClickBooking()"
          class="btn-primary btn-large is-block"
          [class.disabled]="isButtonDisabled"
        >
          {{ 'sharedModule.bkgInitialBookingDataDialog.datesBtn' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
